import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import './Slider.styles.scss'

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper'

const baseSliderData = [
    {
        id: 1,
        image: "https://shawamelsa.com/images/chemical-trading.webp",
        titleKey: 'slider.slide1.title',
        descKey: 'slider.slide1.description'
    },
    {
        id: 2,
        image: "https://www.eigus.com/wp-content/uploads/chemical-trading.jpg",
        titleKey: 'slider.slide2.title',
        descKey: 'slider.slide2.description'
    },
    {
        id: 3,  
        image: "https://trellis.net/wp-content/uploads/2024/07/chem-plant.jpg",
        titleKey: 'slider.slide3.title',
        descKey: 'slider.slide3.description'
    },
    {
        id: 4,
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVvEs1kyr4K84HS-gtCbEy2xarvlfUYqvyNw&s",
        titleKey: 'slider.slide4.title',
        descKey: 'slider.slide4.description'
    }
]

export default function Slider() {
    const { t, i18n } = useTranslation();

    const sliderData = useMemo(() => {
        return baseSliderData.map(slide => ({
            ...slide,
            title: t(slide.titleKey),
            desc: t(slide.descKey)
        }))
    }, [t, i18n.language])

    return (
        <Swiper
            key={i18n.language}
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
                delay: 3500,
                disableOnInteraction: true
            }}
            pagination={{
                clickable: true
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
        >
            {sliderData.map((slide, index) => (
                <SwiperSlide key={slide.id}>
                    <div className="slide-content">
                        <img src={slide.image} alt={slide.title} />
                        <div className="overlay">
                            <h2>{slide.title}</h2>
                            <p>{slide.desc}</p>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}
